/* eslint-disable tailwindcss/enforces-negative-arbitrary-values */
import React from 'react';

import removeInvalidChar from '~/utils/removeInvalidChar';

import DiagonalArrowIcon from '~/assets/icons/ic__system__ diagonal-arrow.svg';

type Props = {
  keyword: string;
  query: string;
};

function RecommendKeyword({ keyword, query }: Props) {
  if (query === '' || !keyword.includes(query)) return null;

  const parts = keyword.split(
    // eslint-disable-next-line spellcheck/spell-checker
    new RegExp(`(${removeInvalidChar(query)})`, 'gi'),
  );

  return (
    <a
      id={`keyword-${keyword}`}
      data-keyword={keyword}
      className="-mt-[1px] flex w-full items-center justify-between border-y border-warmGray-200 py-[10px]"
      tabIndex={-1}
    >
      <span className="typo-paragraph100-regular">
        {parts.map((part, index) =>
          part.toLowerCase() === query.toLowerCase() ? (
            // eslint-disable-next-line react/no-array-index-key
            <span className="text-accent" key={index}>
              {part}
            </span>
          ) : (
            part
          ),
        )}
      </span>
      <DiagonalArrowIcon />
    </a>
  );
}

export default RecommendKeyword;
